<script>
    import R, {LOADER} from "../lib/js/requests";
    import {router} from '../lib/Router/Router.svelte';
    import {PAYMENT_TYPE} from "../lib/js/constants.js";
    import ContactPanel from "../lib/components/ContactPanel.svelte";
    import ReservationDetailsTable from "../book/ReservationDetailsTable.svelte";

    export let hash;

    let reservation = null;

    const load = () => {
        const onSuccess = result => {
            reservation = result;
            reservation.payment_type = PAYMENT_TYPE.CARD;
        }

        const onFailure = err => {
            router.go("/not-found")();
        };

        R.handle(R.reservation.details, hash, onSuccess, onFailure, LOADER.POPUP);
    }

    const checkout = () => {
        const onSuccess = result => {
            if (result.redirect_to) {
                window.location.href = result.redirect_to;
            }
        }

        const onFailure = err => {
        };

        R.handle(R.reservation.checkout, hash, onSuccess, onFailure, LOADER.POPUP);
    }

    load();
</script>

<section class="py-5">
    <div class="container">
        <h1 class="mb-3">Reservation checkout</h1>
        <p class="mb-5">
            You’re ready to continue to the payment page and finalize your booking.
        </p>

        <div class="row">
            <div class="col-xl-7 col-lg-6 mb-4">
                {#if reservation != null}
                    <div class="mb-4">
                        <ReservationDetailsTable {reservation} />
                    </div>

                    <p class="mb-3">
                        Payment is made through
                        <span class="viva-logo"><img src="/app/assets/images/viva-wallet.svg" class="img-fluid"
                                                     alt="viva wallet"/></span>
                        Viva Wallet.<br>
                        You will be transferred to the Viva Wallet platform to complete your payment.
                    </p>

                    <button class="btn btn-primary fw-semibold d-flex align-items-center justify-content-center gap-1 gap-1 w-100 px-0 py-3"
                            on:click={checkout}>
                        <span style="width: 24px;">
                            <img src="/app/assets/images/viva-wallet.svg" class="img-fluid" alt="viva wallet"/>
                        </span>
                        Proceed to Payment
                    </button>
                {/if}
            </div>
            <div class="col-xl-5 col-lg-6">
                <ContactPanel/>
            </div>
        </div>
    </div>
</section>

<style>
    .viva-logo {
        width: 20px;
        display: inline-block;
    }
</style>